// Institutions that had QR code login before the `allowedQRCodeLogins` flag
// existed. Kept as an explicit allowlist so those schools keep working while
// the flag is rolled out from the Admin Portal.
const LEGACY_QR_LOGIN_INSTITUTION_IDS = ['5f25b9fc7fc9788dacc0ce7d', '603faf90396b69a70480e2b2']

/**
 * Whether QR code student logins are enabled for the given institution.
 * True when the institution has `allowedQRCodeLogins` set, or it is one of the
 * legacy allowlisted institutions.
 */
export function isQRCodeLoginEnabled(institution, user) {
    return LEGACY_QR_LOGIN_INSTITUTION_IDS.includes(user?.institution_id) || !!institution?.allowedQRCodeLogins
}

export { LEGACY_QR_LOGIN_INSTITUTION_IDS }
